"use strict";

/* eslint-disable no-param-reassign */
var _ = require('lodash');
var _require = require('../../../common/constant/finding-value.constant'),
  NOT_COMPLIANT = _require.NOT_COMPLIANT;
module.exports = /*@ngInject*/function ($location, $route, $scope, $timeout, $uibModal, $window, ConfirmModelService, dragulaService, ChecklistService, ProfileService, ProgramService, RoutingGroupService, Upload) {
  var ctrl = this;
  ctrl.initFirst = true;
  ctrl.program = null;
  ctrl.configurations = [];
  ctrl.checklist = null;
  ctrl.routingGroups = null;
  ctrl.category = null;
  ctrl.finding = null;
  ctrl.action = null;
  ctrl.isExpand = false;
  ctrl.showUpload = false;
  ctrl.uploading = false;
  ctrl.uploadErrorMessage = null;
  ctrl.superUser = ProfileService.isSuperUser();

  // Finding Actions
  ctrl.CREATE_FINDING_MODE = 'CREATE_FINDING';
  ctrl.EDIT_FINDING_MODE = 'EDIT_FINDING';
  ctrl.REMOVE_FINDING_MODE = 'REMOVE_FINDING';

  // Classification Actions
  ctrl.CREATE_CLASSIFICATION_ACTION = 'CREATE_CLASSIFICATION';
  ctrl.UPDATE_CLASSIFICATION_ACTION = 'UPDATE_CLASSIFICATION';
  ctrl.DELETE_CLASSIFICATION_ACTION = 'DELETE_CLASSIFICATION';
  ctrl.ACTION_FINDING_CANCEL = 'CANCEL';
  ctrl.allowCategoryDrop = true;
  ctrl.allowFindingsDrop = true;
  dragulaService.options($scope, 'category', {
    removeOnSpill: false,
    moves: function moves(element, source, handle) {
      return (
        // allow drag between catogeries
        ctrl.allowCategoryDrop && handle.className.includes('categoryName')
      );
    }
  });
  dragulaService.options($scope, 'findings', {
    removeOnSpill: false,
    accepts: function accepts(el, target, source) {
      return (
        // allow drag only between findings of same category
        ctrl.allowFindingsDrop && source.firstElementChild.id === target.firstElementChild.id
      );
    },
    moves: function moves(element, source, handle) {
      return (
        // allow drag between findings and prevent parent drag when child is dragged
        ctrl.allowFindingsDrop && handle.className.includes('findingName')
      );
    }
  });
  function conflictChecklistModal() {
    ConfirmModelService.confirm(ConfirmModelService.ConfirmType.CONFIRM, {
      message: 'This checklist was edited by another user since your last save, and cannot capture your changes. Please refresh the checklist before making changes.',
      header: 'Conflict Detected',
      buttons: {
        cancel: {
          label: 'Cancel'
        },
        ok: {
          label: 'Refresh'
        }
      }
    }, function () {
      $window.location.reload();
    });
  }
  ctrl.updateChecklist = function (updateFindings) {
    // eslint-disable-next-line no-unused-expressions
    updateFindings ? ctrl.checklist.findings = ctrl.clonedFindings : ctrl.checklist.categories = ctrl.clonedCategories;
    ctrl.allowFindingsDrop = false;
    ctrl.allowCategoryDrop = false;
    ChecklistService.update({
      id: ctrl.checklist._id
    }, ctrl.checklist).$promise.then(function (result) {
      ctrl.allowFindingsDrop = true;
      ctrl.allowCategoryDrop = true;
      ctrl.checklist.lastModified = result.lastModified;
      // eslint-disable-next-line no-unused-expressions
      updateFindings ? ctrl.checklist.findings = result.findings : ctrl.checklist.categories = result.categories;
      ctrl.cloneFindingsAndCategories(ctrl.checklist);
    })["catch"](conflictChecklistModal);
  };
  $scope.$on('category.drop', function (e, el, target, source, sibling) {
    ctrl.onDrop(e, el, target, source, sibling, ctrl.clonedCategories, false);
    ctrl.updateChecklist();
  });
  $scope.$on('findings.drop', function (e, el, target, source, sibling) {
    ctrl.onDrop(e, el, target, source, sibling, ctrl.clonedFindings, true);
    ctrl.updateChecklist(true);
  });
  ctrl.onDrop = function (e, el, target, source, sibling, objArr, isFindingsDragged) {
    var sourceObject = objArr.find(function (obj) {
      return ctrl.formatString(obj, isFindingsDragged) === ctrl.formatInnerText(el[0].innerText.split('\n')[0], isFindingsDragged) && (isFindingsDragged ? el[0].id === obj.categories[0].name : true);
    });
    var destinationObject = objArr.find(function (obj) {
      if (sibling === null) {
        var displayObjArr = target[0].innerText.split('\n');
        return ctrl.formatString(obj, isFindingsDragged) === ctrl.formatInnerText(displayObjArr[displayObjArr.length - 2], isFindingsDragged);
      }
      return ctrl.formatString(obj, isFindingsDragged) === ctrl.formatInnerText(sibling[0].innerText.split('\n')[0], isFindingsDragged);
    });
    if (sibling === null) {
      ctrl.shiftArrayElements(objArr, sourceObject.$$index, destinationObject.$$index);
    } else {
      var index = sourceObject.$$index > destinationObject.$$index ? destinationObject.$$index : destinationObject.$$index - 1;
      ctrl.shiftArrayElements(objArr, sourceObject.$$index, index);
    }
  };
  ctrl.cloneFindingsAndCategories = function (checklist) {
    ctrl.clonedFindings = ctrl.cloneWithIndex(checklist.findings);
    ctrl.clonedCategories = ctrl.cloneWithIndex(checklist.categories);
  };
  ctrl.cloneWithIndex = function (objArr) {
    return _.cloneDeep(objArr).map(function (obj, index) {
      obj.$$index = index;
      return obj;
    });
  };
  ctrl.shiftArrayElements = function (array, fromIndex, toIndex) {
    array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);
  };
  ctrl.formatString = function (obj, isFindingsDragged) {
    var str = isFindingsDragged ? obj.description : obj.name;
    return str.replace(/  +/g, ' ').replace(/\n|\r/g, '');
  };
  ctrl.formatInnerText = function (str, isFindingsDragged) {
    return isFindingsDragged ? str.trim() : str.replace(/\w+[.!?]?$/, '').trim();
  };
  ctrl.findingOptions = {
    CITE: {
      multipleSeries: false,
      showDefaultOptions: false,
      showNoFindingOption: true
    },
    YES_NO: {
      multipleSeries: false,
      showDefaultOptions: true,
      showNoFindingOption: false
    },
    NOT_OBSERVED: {
      multipleSeries: false,
      showDefaultOptions: true,
      showNoFindingOption: false
    }
  };
  ctrl.selectProgram = function (program) {
    ProgramService.get({
      id: program._id
    }, function (result) {
      ctrl.program = result;
      ctrl.getProgramChecklists(ctrl.program);
    });
  };
  ctrl.getProgramChecklists = function (program) {
    ChecklistService.findByProgram({
      programId: program._id
    }).$promise.then(function (checklists) {
      ctrl.checklists = checklists;
      if (ctrl.checklists.length) {
        // eslint-disable-next-line prefer-destructuring
        ctrl.selectedChecklist = ctrl.checklists[0];
        ctrl.getChecklistDetails(ctrl.program, ctrl.selectedChecklist);
      }
    })["catch"](function () {
      ctrl.checklists = [];
    });
  };
  ctrl.getChecklistDetails = function (program, checklist) {
    if (checklist) {
      ctrl.configurations = [];
      ctrl.routingGroups = [];
      ctrl.checklist = {};
      ChecklistService.get({
        id: checklist._id
      }, function (result) {
        ctrl.checklist = result;
        ctrl.cloneFindingsAndCategories(ctrl.checklist);
        ctrl.toggleCategories(false);
        ctrl.showUpload = ctrl.checklist.findings.length === 0 && ProfileService.isSuperUser();
      });
      ctrl.configurations = program.configurations.filter(function (configuration) {
        return configuration.checklist === checklist._id;
      });
      if (ctrl.configurations.length) {
        RoutingGroupService.get({
          id: ctrl.configurations[0].routingGroup
        }).$promise.then(function (routingGroup) {
          ctrl.routingGroups = routingGroup.groups.map(function (group) {
            return group.name;
          });
        })["catch"](function () {
          ctrl.routingGroups = [];
        });
      } else {
        ctrl.routingGroups = [];
      }
    } else {
      ctrl.checklist = {};
      ctrl.routingGroups = [];
    }
  };
  ctrl.uploadTemplate = function (file) {
    ctrl.uploading = true;
    ctrl.uploadErrorMessage = null;
    var request = {
      method: 'POST',
      url: "api/checklist/".concat(ctrl.checklist._id, "/template/upload"),
      file: file
    };
    Upload.upload(request).then(function () {
      ctrl.uploading = false;
      $route.reload();
    })["catch"](function (error) {
      ctrl.uploading = false;
      ctrl.uploadErrorMessage = error.message;
    });
  };
  ctrl.editChecklistDetails = function (checklist) {
    $uibModal.open({
      templateUrl: 'management/checklist/_checklist.basic-edit-form.html',
      controllerAs: '$ctrl',
      backdrop: 'static',
      // eslint-disable-next-line object-shorthand
      controller: /*@ngInject*/function controller($uibModalInstance) {
        var $ctrl = this;
        $ctrl.checklist = {
          _id: checklist._id,
          name: checklist.name,
          showActionPlan: checklist.showActionPlan,
          lastModified: checklist.lastModified
        };
        $ctrl.validate = function (field) {
          $ctrl['checklist-form'][field].$error.duplicate = _.some(ctrl.checklists, function (c) {
            return c.name.toLowerCase() === $ctrl.checklist.name.toLowerCase() && c._id !== $ctrl.checklist._id;
          });
          $ctrl['checklist-form'][field].$setValidity('duplicate', !$ctrl['checklist-form'][field].$error.duplicate, $ctrl['checklist-form'][field]);
        };
        $ctrl.submit = function () {
          $ctrl.progress = true;
          ChecklistService.update({
            id: $ctrl.checklist._id
          }, $ctrl.checklist).$promise.then(function (updatedChecklist) {
            ctrl.checklist = updatedChecklist;
            var matchChecklist = ctrl.checklists.find(function (c) {
              return c._id === updatedChecklist._id;
            });
            Object.assign(matchChecklist, updatedChecklist);
            $uibModalInstance.dismiss('cancel');
          })["catch"](conflictChecklistModal);
        };
        $ctrl.cancel = function () {
          $uibModalInstance.dismiss('cancel');
          ctrl.setAction(null, null);
        };
      }
    });
  };
  ctrl.deleteChecklist = function (checklist, configurations) {
    if (checklist && !configurations.length) {
      $uibModal.open({
        templateUrl: 'management/checklist/_checklist.delete.confirm.html',
        controllerAs: '$ctrl',
        backdrop: 'static',
        // eslint-disable-next-line object-shorthand
        controller: /*@ngInject*/function controller($uibModalInstance) {
          var $ctrl = this;
          $ctrl.ok = function () {
            ChecklistService["delete"]({
              id: checklist._id
            }).$promise.then(function () {
              ctrl.selectProgram(ctrl.program);
              $uibModalInstance.dismiss('cancel');
            });
          };
          $ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
          };
        }
      });
    }
  };
  ctrl.setAction = function (action, category, finding) {
    switch (action) {
      case ctrl.CREATE_FINDING_MODE:
        ctrl.action = action;
        ctrl.setFinding({
          categories: [{
            name: category.name
          }]
        });
        ctrl.setCategory(category);
        break;
      case ctrl.EDIT_FINDING_MODE:
      case ctrl.REMOVE_FINDING_MODE:
        ctrl.action = action;
        ctrl.setFinding(finding);
        ctrl.setCategory(category);
        break;
      case ctrl.ACTION_FINDING_CANCEL:
      default:
        ctrl.action = null;
        ctrl.setFinding(null);
        ctrl.setCategory(null);
        break;
    }
  };
  ctrl.setCategory = function (category) {
    if (!category) {
      ctrl.category = category;
    } else {
      category.$$active = true;
      ctrl.category = _.cloneDeep(category);
    }
  };
  ctrl.isSharedCategory = function (findings, categoryName) {
    return findings.filter(function (finding) {
      return finding.categories.some(function (cat) {
        return cat.name === categoryName;
      });
    }).some(function (finding) {
      return finding.reference && finding.reference.findingId;
    });
  };
  ctrl.setFinding = function (finding) {
    ctrl.finding = !finding ? finding : _.cloneDeep(finding);
  };
  ctrl.getCategoryInFinding = function (finding, category) {
    return _.find(finding.categories, {
      name: category.name
    });
  };
  ctrl.normalizeNgInputData = function (data) {
    return _.map(data, 'text');
  };
  ctrl.submit = function () {
    // eslint-disable-next-line default-case
    switch (ctrl.action) {
      case ctrl.CREATE_FINDING_MODE:
        ctrl.createFinding();
        break;
      case ctrl.EDIT_FINDING_MODE:
        ctrl.updateFinding();
        break;
      case ctrl.REMOVE_FINDING_MODE:
        ctrl.deleteFinding();
        break;
      case ctrl.CREATE_CLASSIFICATION_ACTION:
        ctrl.createClassification(ctrl.classification);
        break;
      case ctrl.UPDATE_CLASSIFICATION_ACTION:
        ctrl.updateClassification(ctrl.oldClassification, ctrl.classification);
        break;
      case ctrl.DELETE_CLASSIFICATION_ACTION:
        ctrl.deleteClassification(ctrl.classification);
        break;
    }
  };
  ctrl.createFinding = function () {
    var clonedFinding = _.cloneDeep(ctrl.finding);
    var categoryInFinding = ctrl.getCategoryInFinding(clonedFinding, ctrl.category);
    if (categoryInFinding) {
      categoryInFinding.tags = ctrl.normalizeNgInputData(categoryInFinding.tags);
      categoryInFinding.routingGroups = ctrl.normalizeNgInputData(categoryInFinding.routingGroups);
      categoryInFinding.filters = ctrl.normalizeNgInputData(categoryInFinding.filters);
    }
    clonedFinding.type = ctrl.checklist.findingsType;
    clonedFinding.daysToResolve = clonedFinding.daysToResolve || null;
    clonedFinding.showDetailOn = NOT_COMPLIANT;
    ChecklistService.createFinding({
      id: ctrl.checklist._id
    }, clonedFinding).$promise.then(function (results) {
      ctrl.checklist = results;
      ctrl.cloneFindingsAndCategories(ctrl.checklist);
      ctrl.setAction(null);
    });
  };
  ctrl.updateFinding = function () {
    var clonedFinding = _.cloneDeep(ctrl.finding);
    var categoryInFinding = ctrl.getCategoryInFinding(clonedFinding, ctrl.category);
    if (categoryInFinding) {
      categoryInFinding.tags = ctrl.normalizeNgInputData(categoryInFinding.tags);
      categoryInFinding.routingGroups = ctrl.normalizeNgInputData(categoryInFinding.routingGroups);
      categoryInFinding.filters = ctrl.normalizeNgInputData(categoryInFinding.filters);
    }
    ChecklistService.updateFinding({
      id: ctrl.checklist._id,
      findingId: ctrl.finding.id
    }, clonedFinding).$promise.then(function (results) {
      ctrl.checklist = results;
      ctrl.cloneFindingsAndCategories(ctrl.checklist);
      ctrl.setAction(null);
    });
  };
  ctrl.deleteFinding = function () {
    ChecklistService.deteleFinding({
      id: ctrl.checklist._id,
      findingId: ctrl.finding.id
    }).$promise.then(function () {
      ctrl.removeFinding(ctrl.finding);
      ctrl.cloneFindingsAndCategories(ctrl.checklist);
      ctrl.setAction(null);
    });
  };
  ctrl.removeCategory = function (category) {
    return _.remove(ctrl.finding.categories, {
      name: category.name
    });
  };
  ctrl.removeFinding = function (finding) {
    return _.remove(ctrl.checklist.findings, {
      id: finding.id
    });
  };
  ctrl.transformCategories = function (categories) {
    return _.map(categories, function (category) {
      return {
        name: category.name,
        tags: [],
        filters: []
      };
    });
  };
  ctrl.selectCategory = function (category, action) {
    if (category) {
      category.$$active = true;
    }
    ctrl.formModel = {
      selected: _.cloneDeep(category),
      form: _.cloneDeep(category) || {
        required: false,
        types: []
      }
    };
    ctrl.action = action;
  };

  // eslint-disable-next-line prefer-object-spread
  ctrl.setCategoryOptions = function (model, options) {
    return Object.assign({}, options, model);
  };
  ctrl.saveCategory = function (form, formModel) {
    formModel.form = ctrl.setCategoryOptions(formModel.form, ctrl.findingOptions[ctrl.checklist.findingsType]);
    ctrl.validateCategoryForm(form, formModel);
    if (form.$valid) {
      ctrl.progress = true;
      if (formModel.selected && _.isEqual(formModel.selected, formModel.form)) {
        ctrl.progress = false;
        ctrl.actionCancel();
      } else {
        ChecklistService.upsertCategory({
          id: ctrl.checklist._id,
          name: formModel.selected ? formModel.selected.name : formModel.form.name
        }, formModel.form).$promise.then(function (result) {
          if (result) {
            ctrl.checklist = result;
          }
        })["finally"](function () {
          ctrl.progress = false;
          ctrl.actionCancel();
        });
      }
    }
  };
  ctrl.validateCategoryForm = function (form, formModel) {
    if (form.$valid) {
      // Validate duplicate category name
      if (form.name.$modelValue) {
        var isExists;
        if (formModel.selected) {
          isExists = _.some(ctrl.checklist.categories, function (category) {
            return category.name.trim().toLowerCase() === form.name.$modelValue.trim().toLowerCase() && formModel.selected.name.trim().toLowerCase() !== category.name.trim().toLowerCase();
          });
        } else {
          isExists = _.some(ctrl.checklist.categories, function (category) {
            return category.name.trim().toLowerCase() === form.name.$modelValue.trim().toLowerCase();
          });
        }
        form.name.$invalid = isExists;
        form.name.$valid = !form.name.$invalid;
        if (isExists) {
          form.name.$error.exists = true;
          form.$valid = false;
          form.$invalid = !form.$valid;
        }
      }
    }
  };
  ctrl.deleteCategory = function (selectedCategory) {
    ctrl.progress = true;
    ChecklistService.deleteCategory({
      id: ctrl.checklist._id,
      name: selectedCategory.name
    }).$promise.then(function (result) {
      if (result) {
        ctrl.checklist = result;
        ctrl.cloneFindingsAndCategories(ctrl.checklist);
      }
    })["finally"](function () {
      ctrl.progress = false;
      ctrl.actionCancel();
    });
  };
  ctrl.toggleCategories = function (expand) {
    if (ctrl.checklist) {
      if (expand !== undefined) {
        ctrl.isExpand = expand;
      } else {
        ctrl.isExpand = !ctrl.isExpand;
      }
      ctrl.checklist.categories.forEach(function (category) {
        category.$$active = ctrl.isExpand;
      });
    }
  };
  ctrl.selectTag = function (tag, action) {
    ctrl.formModel = {
      selected: tag ? {
        name: tag
      } : null,
      form: {
        name: tag
      }
    };
    ctrl.action = action;
  };
  ctrl.saveTag = function (form, formModel) {
    ctrl.validateTagForm(form, formModel);
    if (form.$valid) {
      ctrl.progress = true;
      if (formModel.selected && formModel.selected.name.trim() === formModel.form.name.trim()) {
        ctrl.progress = false;
        ctrl.actionCancel();
      } else {
        ChecklistService.upsertTag({
          id: ctrl.checklist._id,
          name: formModel.selected ? formModel.selected.name : formModel.form.name
        }, formModel.form).$promise.then(function (result) {
          if (result) {
            ctrl.checklist = result;
          }
        })["finally"](function () {
          ctrl.progress = false;
          ctrl.actionCancel();
        });
      }
    }
  };
  ctrl.deleteTag = function (selectedTag) {
    ctrl.progress = true;
    ChecklistService.deleteTag({
      id: ctrl.checklist._id,
      name: selectedTag.name
    }).$promise.then(function (result) {
      if (result) {
        ctrl.checklist = result;
        ctrl.cloneFindingsAndCategories(ctrl.checklist);
      }
    })["finally"](function () {
      ctrl.progress = false;
      ctrl.actionCancel();
    });
  };
  ctrl.validateTagForm = function (form, formModel) {
    if (form.$valid) {
      if (form.tag.$modelValue) {
        var isExists;
        if (formModel.selected) {
          isExists = _.some(ctrl.checklist.tags, function (tag) {
            return tag.trim() === form.tag.$modelValue.trim() && formModel.selected.name.trim() !== tag.trim();
          });
        } else {
          isExists = _.some(ctrl.checklist.tags, function (tag) {
            return tag.trim().toLowerCase() === form.tag.$modelValue.trim().toLowerCase();
          });
        }
        form.tag.$invalid = isExists;
        form.tag.$valid = !form.tag.$invalid;
        if (isExists) {
          form.tag.$error.exists = true;
          form.$valid = false;
          form.$invalid = !form.$valid;
        }
      }
    }
  };
  ctrl.validateName = function () {
    var isDuplicate = _.some(ctrl.checklist.filters, function (classification) {
      return classification === ctrl.classification;
    });
    ctrl['classification-form'].name.$error.duplicate = isDuplicate;
    ctrl['classification-form'].name.$setValidity('duplicate', !isDuplicate, ctrl['classification-form'].name);
  };
  ctrl.actionCancel = function () {
    ctrl.formModel = {
      selected: {},
      form: {}
    };
    ctrl.action = undefined;
    ctrl.classification = null;
  };
  ctrl.newClassification = function (classification) {
    ctrl.checklist.filters.push(classification);
    ctrl.action = null;
  };
  ctrl.setFilter = function (filter, action) {
    ctrl.action = action;
    ctrl.classification = filter;
    ctrl.oldClassification = filter;
  };
  ctrl.createClassification = function (classification) {
    ctrl.progress = true;
    ChecklistService.createClassification({
      id: ctrl.checklist._id
    }, {
      classification: classification
    }).$promise.then(function () {
      return ChecklistService._get({
        id: ctrl.checklist._id
      }).$promise;
    }).then(function (checklist) {
      ctrl.checklist = checklist;
      ctrl.actionCancel();
      ctrl.progress = false;
    })["catch"](function () {
      ctrl.progress = false;
    });
  };
  ctrl.updateClassification = function (oldClassification, newClassification) {
    ctrl.progress = true;
    ChecklistService.updateClassification({
      id: ctrl.checklist._id,
      name: oldClassification
    }, {
      classification: newClassification
    }).$promise.then(function () {
      return ChecklistService._get({
        id: ctrl.checklist._id
      }).$promise;
    }).then(function (checklist) {
      ctrl.checklist = checklist;
      ctrl.actionCancel();
      ctrl.progress = false;
    })["catch"](function () {
      ctrl.progress = false;
    });
  };
  ctrl.deleteClassification = function (classification) {
    ctrl.progress = true;
    ChecklistService.deleteClassification({
      id: ctrl.checklist._id,
      name: classification
    }).$promise.then(function () {
      return ChecklistService._get({
        id: ctrl.checklist._id
      }).$promise;
    }).then(function (checklist) {
      ctrl.checklist = checklist;
      ctrl.actionCancel();
      ctrl.progress = false;
    })["catch"](function () {
      ctrl.progress = false;
    });
  };
  $scope.$watch(function () {
    return $location.search();
  }, function (newSearch, oldSearch) {
    if (newSearch.program !== oldSearch.program || ctrl.initFirst) {
      ctrl.initFirst = false;
      ctrl.selectProgram({
        _id: $location.search().program
      });
      ctrl.formModel = {
        selected: {},
        form: {}
      };
      ctrl.action = undefined;
    }
  }, true);
};